import Elemento from './Elemento.js';

export default class Modelo extends Elemento {
  constructor() {
    super();
    this.referenciaSel = new String();
    this.estandares = new Array();
    this.campoSel = new String();
    this.campos = new Array();
    this.getCampo = function (param) {
      var element = param == undefined ? (element = this.campoSel) : param;

      var filter = this.campos.find((campoEl) => campoEl.cod == element);

      return filter != undefined ? filter : this.campos[0];
    };
  }
}
